import { getCategoryHref } from '../../utils/common/category';
import { CONTENT_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'contentTitleGeneratorType',
      analyticsName: 'content_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: CONTENT_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Content',
        value: getCategoryHref(CONTENT_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'contentTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'content_titles_generator',
      placeholder: 'Try "videos for my healthy food blog" or "Instagram stories for shoe brand"',
      textLabel: 'Describe the content’s topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: CONTENT_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
